import React, { Fragment } from 'react';
import pluralize from 'pluralize';
import PropTypes from 'prop-types';
import { useHistory } from 'react-router-dom';

import AlbumsIcon from '../../../../../../../../components/icons/AlbumFolderGalleryIcon';
import Button from '../../../../../../../../components/global/Button';
import ProfilePageCard from '../../../ProfilePageCard';
import { getDateLabel } from '../../../../../../../../util/album';
import UploadIcon from '../../../../../../../../components/icons/UploadIcon';
import { ALL_PHOTOS_MODE } from '../../../../../../../../constants/album-folder';

const propTypes = {
  className: PropTypes.string,
  hierarchyItem: PropTypes.shape({
    childAlbumCount: PropTypes.number,
    coverPhotoUrl: PropTypes.string,
    name: PropTypes.string.isRequired,
    startDate: PropTypes.string,
    hasUploadPermissions: PropTypes.bool,
  }).isRequired,
  onItemClick: PropTypes.func,
  onUpload: PropTypes.func,
  primary: PropTypes.bool,
};

const HierarchyItemCard = ({
  className,
  hierarchyItem,
  onItemClick,
  onUpload,
  primary = false,
}) => {
  const history = useHistory();

  const {
    childAlbumCount,
    coverPhotoUrl,
    name,
    hasUploadPermissions,
    album_folder: albumFolder,
  } = hierarchyItem;

  const isPublicAllPhotos =
    albumFolder?.all_photos_mode === ALL_PHOTOS_MODE.PUBLIC;
  const { picture_day_enabled: isPictureDay } = albumFolder ?? {};

  return (
    <ProfilePageCard
      onClick={onItemClick}
      className={className}
      title={name}
      thumbnailUrl={coverPhotoUrl}
      isDefaultThumbnail={!coverPhotoUrl}
      isPictureDay={isPictureDay}
      subtitle={`${getDateLabel(hierarchyItem)}`}
      note={
        childAlbumCount > 0 && !isPictureDay
          ? `${childAlbumCount} ${pluralize('album', childAlbumCount)}`
          : ''
      }
      icon={primary ? <AlbumsIcon /> : null}
      thumbnailActions={
        <Fragment>
          {hasUploadPermissions && (
            <Button
              btnSize="xs"
              className="profile-page-card-button-icon"
              btnStyle="reset"
              onClick={() => onUpload(hierarchyItem)}
            >
              <UploadIcon size={22} />
            </Button>
          )}
          {!!isPictureDay && !coverPhotoUrl && !isPublicAllPhotos && (
            <Button
              btnSize="sm"
              btnStyle="white"
              btnOutline
              onClick={() =>
                history.push(`/discover/album-folder/${albumFolder?.id}/start`)
              }
            >
              Join now
            </Button>
          )}
        </Fragment>
      }
      thumbnailActionsClassName={
        isPictureDay ? 'picture-day-thumbnail-actions' : undefined
      }
    />
  );
};

HierarchyItemCard.propTypes = propTypes;

export default HierarchyItemCard;
